import { h } from 'preact';

/**
 * Gets the closest parent element that matches a given selector
 */
export const getClosest = (el, s) => {
	for ( ; el && el !== document; el = el.parentNode ) {
		if ( el.matches(s) ) return el;
	}
	return null;
};

/**
 * Open searches in new window unless already on serp page
 */
export function openSearchInNewWindow() {
	// causing issues in FF.  Disable for now.
	return false;
	//return window.location.pathname.indexOf('/search') !== 0;
}

/**
 * Creates the full navigation menu to be used
 */
export function createNavigation(navigationSections, navigationLinks) {
	// Should always be an array, else return empty menu
	if (!Array.isArray(navigationLinks)) return [];

	return navigationLinks.reduce((result, link) => {
	  if (typeof link === 'string') {
	    link = navigationSections[link];
	  }
	  link && result.push(link);
	  return result;
	}, []);
}
